export default __webpack_public_path__ + "static/media/img_follow_us.2e12dbb9.png";